import { RouteType } from '@/lib/route';
import QuizFeedbackComponent from '.';

const QuizFeedbackRoutes: RouteType = {
  path: '/module/:elearningId/quiz/feedback',
  component: QuizFeedbackComponent,
};

export default QuizFeedbackRoutes;
